const yellow200Color = '#F1E39D';

export default yellow200Color;
